// export const locale = process.env.REACT_APP_API_LANG ? process.env.REACT_APP_API_LANG : 'fr'


export const setLocale = () => {

    const pattern = /[a-z]{2,}/g;
    const tld = window.location.origin.match(pattern).pop();

    if (tld === 'it') {
        return tld;
    }
    return 'fr';
}

export const locale = setLocale();
